// extracted by mini-css-extract-plugin
module.exports = {"root":"page-module--root--3WkLP","content":"page-module--content--1CPtJ"};